import parseISO from "date-fns/parseISO";
import { client as request } from "./request";
import ProjectMember from "@/models/project-member";
import ID from "@/models/id";

export interface Message {
  messageId: any;
  body: string;
  created: Date;
  from: ProjectMember;
  to: ProjectMember[];
}

export interface ProjectMessage {
  projectId: ID;
  projectName: string;
  messageList: Message[];
}

function Message(data: any): Message {
  return {
    ...data,
    from: new ProjectMember(data.from),
    to: data.to ? data.to.map((m: any) => new ProjectMember(m)) : [],
    created: parseISO(data.created)
  };
}

function Messages(data: any) {
  return {
    lastReadMessageCreated: data.lastReadMessageCreated,
    messages: data.messageList.map(Message)
  };
}

export async function getMessages(
  projectId: any,
  messageId: any = "0",
  direction: "newer" | "older" = "newer"
) {
  const res = await request.get("get_messages.php", {
    projectId,
    messageId,
    direction
  });
  return Messages(res);
}

export async function getNewerMessages(projectId: any, messageId: any) {
  return await getMessages(projectId, messageId, "newer");
}

export async function getOlderMessages(projectId: any, messageId: any) {
  // olderだとmessageId必須なので最初だけ切り替える
  const direction = String(messageId) === "0" ? "newer" : "older";
  return await getMessages(projectId, messageId, direction);
}

export async function saveMessage(data: FormData) {
  const res = await request.post("save_message.php", data).catch(e => {
    alert(e);
  });

  return res.messageId;
}

export async function readMessage(projectId: any, messageId: any) {
  const data = new FormData();
  data.append("projectId", projectId);
  data.append("messageId", messageId);
  await request.post("read_message.php", data);
}

/**
 * 各現場の未読メッセージを得る
 */
export async function getUnreadReplyMessages(projectIds: ID[]) {
  const res = await request.get("get_unread_reply_messages.php", {
    projectIds
  });
  return res.projectUnreadMessageInfoList.map((p: any) => ({
    ...p,
    messageList: p.messageList.map(Message)
  })) as ProjectMessage[];
}
